module.exports = __webpack_public_path__ + "media/images/icon__point--lost@2x-bb43325af49c619eabda6cb42f58ef27.png";